import styled from "styled-components";

export const ShowMoreStyled = styled.div`
  .data-view {
    color: ${({ theme }): string => theme.textColors.BLACK_COLOR};
    margin-right: 5px;
  }
`;
